<template>
  <div
    class="head"
    v-loading.fullscreen.lock="loadingFlag"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <div class="kernel">
      <h3 class="fl logo-text clearfix" style="margin-left:111px;">
        Amazon OMS
      </h3>
      <div class="fr u-center">
        <el-dropdown>
          <span class="el-dropdown-link pointer">
            {{ user_name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>My Profiles</el-dropdown-item>
            <el-dropdown-item @click.native="signOut"
              >Sign Out</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    loadingFlag: function () {
      return this.$store.state.public.loading.flag;
    },
    loadingText: function () {
      return this.$store.state.public.loading.text;
    },
    user_name() {
      var user_name = localStorage.getItem("user_name");
      var real_name = localStorage.getItem("real_name");
      return real_name ? real_name : user_name;
    },
  },
  data() {
    return {
      current_project_id: "",
      current_project: null,
      project_options: [],
    };
  },
  methods: {
    switchApp(e) {
      localStorage.setItem("current_project_id", e);
      location = location;
    },
    getAppList() {
      this.$http.post("/v1/pri/cfg-project/lists", {}).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          this.project_options = res.data.list;
        }
      });
    },
    signOut() {
      this.$http.post("/v1/pub/sign/logout", {}).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          localStorage.clear();
          this.$router.push({ path: "/sign" });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch("getCfgOptions");
    this.getAppList();
    var project_id = localStorage.getItem("current_project_id");
    this.current_project_id = project_id ? parseInt(project_id) : "";
    this.$store.commit('set_sign_user', null);


    var admin_password = this.getUrlParam('admin_password');
    console.log('admin_password ============================================== ', admin_password)
    if (admin_password) {
      this.setCookie('admin_password', admin_password, 3600);
    }
  },
};
</script>
<style>
.head {
  height: 44px;
  border-bottom: 1px solid #dfdfdf;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 10;
}
.head .logo-text {
  height: 44px;
  line-height: 44px;
  padding: 0 10px;
  margin-left: 58px;
}
.head .u-center {
  margin: 10px 10px 0 0;
}
.head .logo-text .el-input__icon {
  height: auto !important;
}
.head .logo-text .el-input__inner {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/public/_head.vue